module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Western Water - Introduction")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-sm-1 col-sm-10 offset-lg-1 col-lg-10"
  }, [_c('p', [_vm._v("Much of the American West is in a prolonged drought. Western Water tracks the water levels of reservoirs in several western states. It is a proxy for water availability\n        in the selected states more generally. Results will be updated monthly. The initial goal was to update levels daily,\n        but there isn't enough daily change in reservoir levels to warrant such granularity.")]), _vm._v(" "), _c('p', [_vm._v("Western Water does not include water from desalination plants, ground water, or water pulled directly from rivers\n        Instead it focuses on water stored in reservoirs.")]), _vm._v(" "), _c('p', [_vm._v("Data does not include every reservoir in California. Data for some reservoirs was not available for various reasons; mainly due to\n        an inability to scrape data or determine a reservoir's capacity. Nor is water from reservoirs on the Colorado river,\n        which provides water to much of southern California, as I found no way\n        to quantify how much water in each reservoir: Havasu, Mead and Powell, belongs to California, as each\n        reservoir lies wholly or in part outside the state. The Colorado River\n        Compact guarantees California 4,400,000 acre feet a year. So\n        you can spread it among the Colorado River reservoirs however you see fit. If there\n        is a shortfall in available water in the river California's water rights trump Arizona's.")]), _vm._v(" "), _c('p', [_vm._v("Texas reservoir data should be complete. a class=\"inside\" handful of reservoirs in Texas are shared with other states or countries, with\n        the water split as a percentage between the agreement partners. The reservoir capacities and volume in the visualization\n        are based on Texas' percentages, except as noted below.")]), _vm._v(" "), _c('p', [_vm._v("The shared reservoirs are (per "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://waterdatafortexas.org/"
    }
  }, [_vm._v("http://waterdatafortexas.org")]), _vm._v("):\n      "), _c('ul', [_c('li', [_vm._v("Lake Amistad, shared with Mexico: 56.2% of reservoir belongs to Texas.")]), _vm._v(" "), _c('li', [_vm._v("Lake Falcon, shared with Mexico: 58.6% of reservoir belongs to Texas.")]), _vm._v(" "), _c('li', [_vm._v("Caddo Lake, shared with Louisiana: 50.0% of reservoir belongs to Texas")]), _vm._v(" "), _c('li', [_vm._v("Elephant Butte Lake, shared with Colorado, New Mexico, Texas and the Mexican state of Chihuahua.")]), _vm._v(" "), _c('li', [_vm._v("Lake Meredith, shared with New Mexico and Oklahoma: 500,000 acre feet belong to Texas after New Mexico's\n          allotment of 200,000 acre feet are held in Ute Lake. Texas must release water beyond its allotment\n          to Oklahoma.")]), _vm._v(" "), _c('li', [_vm._v("Lake Texoma, shared with Oklahoma: 50.0% of reservoir belongs to Texas")]), _vm._v(" "), _c('li', [_vm._v("Toledo Bend Reservoir, shared with Louisiana: 50.0% of reservoir belongs to Texas")])])]), _c('p', [_vm._v("The goal is to include reservoirs from across the west, particularly the states in the Colorado River basin:\n        Colorado, Wyoming, Utah, New Mexico, Nevada, Arizona and California. However, it has been difficult to find historical\n        data for most states. For example, the United States Bureau of Reclamation maintains separate web sites for the upper and lower\n        Colorado. Reclamation staff have been very helpful in navigating their data, but technological issues with loading pages from the\n        Bureau's sites have made it difficult to grab data via scripting.  More often than not, page loads\n        fail when accessing Bureau data via Curl.\n      ")]), _vm._v(" "), _c('p', [_vm._v("Historical averages would be a nice addition. These are available for California reservoirs, but not for other states or snow\n        data. My plan is to calculate averages from the data I do have.")]), _vm._v(" "), _c('p', [_vm._v("Ground water usage is also of interest, though data is difficult if not impossible\n        to obtain, as for instance, California doesn't track groundwater use.")]), _vm._v(" "), _c('p', [_vm._v("Data courtesy of the following locations:")]), _vm._v(" "), _c('ul', {
    staticClass: "no-style"
  }, [_c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://cdec.water.ca.gov"
    }
  }, [_vm._v("California Data Exchange Center")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://waterdatafortexas.org/"
    }
  }, [_vm._v("Water Data for Texas")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://waterdata.usgs.gov/"
    }
  }, [_vm._v("United States Geological Survey - National Water Information System")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://www.usbr.gov/"
    }
  }, [_vm._v("United States Bureau of Reclamation")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://data.hydrometdataservice.info/dwr/"
    }
  }, [_vm._v("Salt River Project")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://www.nwd.usace.army.mil/Media/Fact-Sheets/Fact-Sheet-Article-View/Article/475820/columbia-river-basin-dams/"
    }
  }, [_vm._v("US Army Corps of Engineers - Northwestern Division")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://www.wcc.nrcs.usda.gov/snow/"
    }
  }, [_vm._v("United States Dept of Agriculture - Natural Resources Conservation Service")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://www.denverwater.org/SupplyPlanning/WaterSupply/ReservoirLevels/"
    }
  }, [_vm._v("Denver Water")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://www.waterquality.utah.gov/"
    }
  }, [_vm._v("Utah Department of Environmental Quality - Division of Water Quality")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://en.wikipedia.org/"
    }
  }, [_vm._v("Wikipedia")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://tools.wmflabs.org/geohack/"
    }
  }, [_vm._v("GeoHack")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://www.lat-long.com/"
    }
  }, [_vm._v("http://www.lat-long.com")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://catalog.opendata.city/"
    }
  }, [_vm._v("opendata.city")])])]), _vm._v(" "), _c('p', [_vm._v("Project built using:")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://d3js.org/"
    }
  }, [_vm._v("D3.js")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://vuejs.org"
    }
  }, [_vm._v("Vue.js")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://simplehtmldom.sourceforge.net/"
    }
  }, [_vm._v("PHP Simple HTML DOM Parser")])])]), _vm._v(" "), _c('p', [_vm._v("If you have questions or comments feel free to contact me on Twitter at "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://twitter.com/farrelldlfarrel"
    }
  }, [_vm._v("@farrelldlfarrel")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26bd8460"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 369
// module chunks = 1